import { Stack } from '@mui/material';
import styled from 'styled-components';

export const DotsContainer = styled(Stack)`
  && {
    svg {
      color: ${({ theme }) => theme.palette.secondary.main};
      height: 0.375rem;
      width: 0.375rem;
    }
  }
`;

export const LicenseToggleContainer = styled(Stack)`
  && {
    button {
      padding: 0;
      height: 1.5rem;
    }
  }
`;
